export default __webpack_public_path__ + "static/media/Snd_TryJ.6ead9d34.mp3";